import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import {
  getCloudEnvTableColumn,
  getEnableDateTableColumn,
  getBrandTableColumn,
  getAccountTableColumn,
  getCloudProividerTableColumn,
  getRatioTableColumn,
  getProjectDomainTableColumn,
  getCurrencyAppliedTableColumn,
  getRuleTypeColumn,
  getOwnerTableColumn,
} from '../utils/columns'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      getProjectDomainTableColumn(),
      getEnableDateTableColumn(),
      getCloudEnvTableColumn(),
      getBrandTableColumn(),
      getAccountTableColumn(),
      getCloudProividerTableColumn(),
      getOwnerTableColumn(),
      getRuleTypeColumn(),
      getRatioTableColumn(),
      getCurrencyAppliedTableColumn(),
      getTimeTableColumn(),
    ]
  },
}
